import Keycloak from "keycloak-js";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL as string,
  realm: import.meta.env.VITE_KEYCLOAK_REALM as string,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string,
});

interface KeycloakContextValue {
  keycloak: Keycloak;
  isInit: boolean;
  error: string | null;
}

export const KeycloakContext = createContext<KeycloakContextValue>(
  {} as KeycloakContextValue,
);

export function useKeycloak() {
  return useContext(KeycloakContext);
}

export function KeycloakProvider({ children }: { children: React.ReactNode }) {
  const [isInit, setIsInit] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const hasRun = useMemo(() => ({ current: false }), []);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const redirectUri = window.location.origin + "/";

    keycloak
      .init({ onLoad: "login-required", checkLoginIframe: false, redirectUri })
      .then((auth) => {
        if (!auth) {
          window.location.reload();
        } else {
          // Sincroniza (find-or-create) usuário local e role a partir do token Keycloak
          fetch("/api/v1/auth/keycloak/sync", {
            method: "POST",
            headers: { Authorization: `Bearer ${keycloak.token ?? ""}` },
          })
            .catch(() => {})
            .finally(() => setIsInit(true));
        }
      })
      .catch((err: unknown) => {
        const msg = err instanceof Error ? err.message : String(err);
        setError(msg);
      });
  }, [hasRun]);

  return (
    <KeycloakContext.Provider value={{ keycloak, isInit, error }}>
      {children}
    </KeycloakContext.Provider>
  );
}

